<template>
  <div id="editUserInternalModal">
    <CModal
      :show.sync="showModal"
      size="lg"
      :centered="true"
      :closeOnBackdrop="false"
    >
      <CForm>
        <CInput
          label="Name"
          horizontal
          placeholder="Enter name..."
          v-model="inputName"
          required
          was-validated
        />
        <CInput
          type="email"
          autocomplete="email"
          label="Email"
          horizontal
          placeholder="Enter Email..."
          v-model="inputEmail"
          required
          was-validated
        />
        <CInput
          type="tel"
          autocomplete="tel"
          label="Phone number"
          horizontal
          placeholder="+6591234567"
          v-model="inputPhone"
          pattern="^\+[1-9]\d{7,14}$"
          required
          was-validated
        />
      </CForm>
      <template #header>
        <h5 class="modal-title">Edit User Internal</h5>
        <CButtonClose @click="closeModal" />
      </template>
      <template #footer>
        <CButton @click="closeModal" color="secondary">Cancel</CButton>
        <CButton @click="onSave" color="primary">Save</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
export default {
  name: 'EditUserInternalModal',
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      inputName: '',
      inputEmail: '',
      inputPhone: '',
    };
  },
  watch: {
    user: {
      immediate: true,
      handler(val) {
        if (val) {
          this.inputName = val.name || '';
          this.inputEmail = val.email || '';
          this.inputPhone = val.phone_number || '';
        }
      },
    },
  },
  methods: {
    closeModal() {
      if (this.user) {
        this.inputName = this.user.name || '';
        this.inputEmail = this.user.email || '';
        this.inputPhone = this.user.phone_number || '';
      }
      this.$emit('close-modal');
    },
    onSave(e) {
      if (this.inputName && this.inputEmail && this.inputPhone) {
        this.$emit('save', {
          name: this.inputName,
          email: this.inputEmail,
          phone: this.inputPhone,
        });
      }
      if (e) {
        e.preventDefault();
      }
    },
  },
};
</script>
